import { PrescriptionProvider } from '@context/Prescription';

import PrescriptionView from './PrescriptionView';

const Prescription = () => {
  return (
    <PrescriptionProvider>
      <PrescriptionView />
    </PrescriptionProvider>
  );
};

export default Prescription;
